(function () {
  'use strict';

  angular
    .module('garanteasyApp')
    .factory('ImportService', ImportService);

  ImportService.$inject = ['$resource', 'API_URI'];

  function ImportService($resource, API_URI) {
    var resourceUrl = API_URI + 'management/products-import/:id';
    return $resource(resourceUrl, {}, {
      'get': {method: 'GET'},
      'insert': {method: 'POST'}
    });
  }
})();
